// TEPO Fullscreen Modal JavaScript
// Handles modal interactions and enhances functionality

(function() {
    'use strict';
    
    // Configuration
    const config = {
        modalSelector: '.vue-universal-modal.tcustomizer-dialog',
        closeButtonSelector: '.tcustomizer-dialog-close',
        imageWrapperSelector: '.tcustomizer__image-wrapper',
        radioInputSelector: '.tcustomizer__btn-check',
        bodyClass: 'tepo-modal-open',
        animationDuration: 400,
        swipeThreshold: 50
    };
    
    class TEPOFullscreenModal {
        constructor() {
            this.modal = null;
            this.isOpen = false;
            this.touchStartY = 0;
            this.touchEndY = 0;
            this.init();
        }
        
        init() {
            this.setupEventListeners();
            this.enhanceModalFunctionality();
            this.watchPhotoSizeVisibility();
        }
        
        watchPhotoSizeVisibility() {
            // console.log('TEPO Fullscreen Modal: Watching for swau-photo-size visibility...');
            
            // Use MutationObserver to watch for changes to the swau-photo-size element
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes') {
                        const target = mutation.target;
                        if (target.classList && target.classList.contains('swau-photo-size')) {
                            // console.log('TEPO Fullscreen Modal: swau-photo-size element changed');
                            this.checkPhotoSizeVisibility(target);
                        }
                    }
                    // Also check for child additions/removals
                    if (mutation.type === 'childList') {
                        const addedNodes = Array.from(mutation.addedNodes);
                        const removedNodes = Array.from(mutation.removedNodes);
                        
                        const hasPhotoSizeChanges = [...addedNodes, ...removedNodes].some(node => 
                            node.nodeType === 1 && (
                                node.classList?.contains('swau-photo-size') ||
                                node.querySelector?.('.swau-photo-size')
                            )
                        );
                        
                        if (hasPhotoSizeChanges) {
                            // console.log('TEPO Fullscreen Modal: swau-photo-size DOM changes detected');
                            setTimeout(() => this.checkPhotoSizeVisibility(), 100);
                        }
                    }
                });
            });
            
            // Start observing with broader scope
            observer.observe(document.body, {
                attributes: true,
                subtree: true,
                childList: true,
                attributeFilter: ['style', 'class']
            });
            
            // Also check periodically in case MutationObserver misses something
            setInterval(() => {
                this.checkPhotoSizeVisibility();
            }, 500);
            
            // Check immediately
            setTimeout(() => this.checkPhotoSizeVisibility(), 100);
        }
        
        checkPhotoSizeVisibility(photoSizeElement = null) {
            // Find the photo size element if not provided
            if (!photoSizeElement) {
                photoSizeElement = document.querySelector('.swau-photo-size');
            }
            
            if (!photoSizeElement) {
                // console.log('TEPO Fullscreen Modal: swau-photo-size element not found');
                this.togglePhotoSelectionVisibility(false);
                return;
            }
            
            // Check multiple ways to determine visibility
            const isVisible = (
                photoSizeElement.style.display !== 'none' && 
                photoSizeElement.offsetParent !== null &&
                !photoSizeElement.classList.contains('swau-photo-option-hidden') &&
                photoSizeElement.offsetWidth > 0 &&
                photoSizeElement.offsetHeight > 0
            );
            
            // console.log('TEPO Fullscreen Modal: Photo size element visibility check:', {
            //     element: photoSizeElement,
            //     display: photoSizeElement.style.display,
            //     offsetParent: photoSizeElement.offsetParent,
            //     offsetWidth: photoSizeElement.offsetWidth,
            //     offsetHeight: photoSizeElement.offsetHeight,
            //     isVisible: isVisible
            // });
            
            this.togglePhotoSelectionVisibility(isVisible);
        }
        
        togglePhotoSelectionVisibility(isVisible) {
            // Find the photo selection option (the one with swau-custom-photo-select class)
            const photoSelectionOption = document.querySelector('.swau-custom-photo-select');
            
            // console.log('TEPO Fullscreen Modal: Toggling photo selection visibility...');
            // console.log('Photo selection option found:', photoSelectionOption);
            // console.log('Photo size element visible:', isVisible);
            
            if (photoSelectionOption) {
                if (isVisible) {
                    // Use class-based approach instead of inline styles
                    photoSelectionOption.classList.add('swau-photo-option-visible');
                    photoSelectionOption.classList.remove('swau-photo-option-hidden');
                    // console.log('TEPO Fullscreen Modal: Showing photo selection option');
                } else {
                    // Use class-based approach instead of inline styles
                    photoSelectionOption.classList.add('swau-photo-option-hidden');
                    photoSelectionOption.classList.remove('swau-photo-option-visible');
                    // console.log('TEPO Fullscreen Modal: Hiding photo selection option');
                }
            } else {
                // console.log('TEPO Fullscreen Modal: Photo selection option not found!');
            }
        }

        setupEventListeners() {
            // Listen for modal appearance
            this.observeModalChanges();
            
            // Close button functionality - more robust
            document.addEventListener('click', (e) => {
                const closeButton = e.target.closest(config.closeButtonSelector);
                if (closeButton) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.closeModal();
                }
            });
            
            // Background click to close
            document.addEventListener('click', (e) => {
                if (e.target.closest(config.modalSelector) && 
                    !e.target.closest('.vue-universal-modal-content')) {
                    this.closeModal();
                }
            });
            
            // Image click to close - simulate X button click after photo selection
            document.addEventListener('click', (e) => {
                const imageWrapper = e.target.closest(config.imageWrapperSelector);
                if (imageWrapper && this.isOpen) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Let TEPO process the photo selection first
                    setTimeout(() => {
                        // Find and click the X button to close the modal
                        const closeButton = this.modal.querySelector('.tcustomizer-dialog-close');
                        if (closeButton) {
                            closeButton.click();
                        }
                    }, 100); // Small delay to ensure TEPO processes the selection
                }
            });
            
            // Keyboard events
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && this.isOpen) {
                    this.closeModal();
                }
            });
            
            // Touch events for swipe to close
            this.setupTouchEvents();
            
            // Prevent body scroll when modal is open
            this.preventBodyScroll();
        }
        
        observeModalChanges() {
            // Use MutationObserver to detect when TEPO modal appears
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        mutation.addedNodes.forEach((node) => {
                            if (node.nodeType === Node.ELEMENT_NODE) {
                                if (node.matches && node.matches(config.modalSelector)) {
                                    this.modal = node;
                                    this.openModal();
                                } else if (node.querySelector && node.querySelector(config.modalSelector)) {
                                    this.modal = node.querySelector(config.modalSelector);
                                    this.openModal();
                                }
                            }
                        });
                        
                        mutation.removedNodes.forEach((node) => {
                            if (node.nodeType === Node.ELEMENT_NODE) {
                                if (node.matches && node.matches(config.modalSelector)) {
                                    this.closeModal();
                                }
                            }
                        });
                    }
                });
            });
            
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
            
            // Also check for existing modals on page load
            this.checkForExistingModal();
        }
        
        checkForExistingModal() {
            const existingModal = document.querySelector(config.modalSelector);
            if (existingModal && existingModal.classList.contains('vue-universal-modal-show')) {
                this.modal = existingModal;
                this.openModal();
            }
        }
        
        openModal() {
            if (!this.modal || this.isOpen) return;
            
            console.log('TEPO Fullscreen Modal: Opening modal...');
            console.log('Modal element:', this.modal);
            console.log('Modal classes before:', this.modal.className);
            
            this.isOpen = true;
            document.body.classList.add(config.bodyClass);
            
            // Add custom class for styling
            this.modal.classList.add('tepo-fullscreen-modal');
            
            // Update image URLs to higher quality
            this.updateImageUrls();
            
            // Set up photo selection tracking
            this.setupPhotoSelectionTracking();
            
            // Trigger entrance animations
            this.triggerEntranceAnimations();
            
            // Focus management
            this.manageFocus();
            
            // Prevent body scroll
            this.preventBodyScroll();
            
            // Use CSS animation instead of inline styles
            this.modal.classList.add('tepo-fade-in-animation');
            
            console.log('TEPO Fullscreen Modal: Added fade-in animation class');
            
            // Log for debugging
            console.log('TEPO Fullscreen Modal: Opened');
        }
        
        closeModal() {
            if (!this.isOpen) return;
            
            console.log('TEPO Fullscreen Modal: Closing modal...');
            console.log('Modal classes before close:', this.modal.className);
            
            this.isOpen = false;
            document.body.classList.remove(config.bodyClass);
            
            // Use CSS animation for closing
            if (this.modal) {
                this.modal.classList.add('tepo-fade-out-animation');
                console.log('TEPO Fullscreen Modal: Added fade-out animation class');
                
                // Remove classes after animation
                setTimeout(() => {
                    if (this.modal) {
                        // Don't remove vue-universal-modal-show - TEPO needs it for re-opening
                        this.modal.classList.remove('tepo-fullscreen-modal');
                        this.modal.classList.remove('tepo-fade-in-animation');
                        this.modal.classList.remove('tepo-fade-out-animation');
                        
                        console.log('TEPO Fullscreen Modal: Removed animation classes');
                        console.log('Modal classes after close:', this.modal.className);
                    }
                }, 400); // Match the transition duration
            }
            
            // Trigger close animation
            this.triggerCloseAnimation();
            
            // Restore body scroll
            this.preventBodyScroll();
            
            // Log for debugging
            console.log('TEPO Fullscreen Modal: Closed');
        }
        
        triggerEntranceAnimations() {
            if (!this.modal) return;
            
            // Add entrance animation class
            const imageWrappers = this.modal.querySelectorAll(config.imageWrapperSelector);
            imageWrappers.forEach((wrapper, index) => {
                wrapper.style.animationDelay = `${(index + 1) * 0.1}s`;
                wrapper.classList.add('animate-in');
            });
        }
        
        triggerCloseAnimation() {
            if (!this.modal) return;
            
            // Add close animation class
            this.modal.classList.add('closing');
            
            setTimeout(() => {
                if (this.modal) {
                    this.modal.classList.remove('closing');
                }
            }, config.animationDuration);
        }
        
        setupTouchEvents() {
            document.addEventListener('touchstart', (e) => {
                if (!this.isOpen || !this.modal) return;
                
                this.touchStartY = e.touches[0].clientY;
            }, { passive: true });
            
            document.addEventListener('touchmove', (e) => {
                if (!this.isOpen || !this.modal) return;
                
                this.touchEndY = e.touches[0].clientY;
                const diff = this.touchStartY - this.touchEndY;
                
                // Only allow downward swipe to close
                if (diff < -config.swipeThreshold) {
                    this.closeModal();
                }
            }, { passive: true });
        }
        
        preventBodyScroll() {
            // Use CSS to prevent body scroll instead of JavaScript
            // This allows modal scrolling to work naturally
            if (this.isOpen) {
                document.body.style.overflow = 'hidden';
                document.body.style.position = 'fixed';
                document.body.style.width = '100%';
            } else {
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.width = '';
            }
        }
        
        manageFocus() {
            if (!this.modal) return;
            
            // Focus the first interactive element
            const firstFocusable = this.modal.querySelector('input, button, [tabindex]:not([tabindex="-1"])');
            if (firstFocusable) {
                firstFocusable.focus();
            }
            
            // Trap focus within modal
            this.trapFocus();
        }
        
        trapFocus() {
            if (!this.modal) return;
            
            const focusableElements = this.modal.querySelectorAll(
                'input, button, [tabindex]:not([tabindex="-1"])'
            );
            
            if (focusableElements.length === 0) return;
            
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];
            
            const handleTabKey = (e) => {
                if (e.key === 'Tab') {
                    if (e.shiftKey) {
                        if (document.activeElement === firstElement) {
                            e.preventDefault();
                            lastElement.focus();
                        }
                    } else {
                        if (document.activeElement === lastElement) {
                            e.preventDefault();
                            firstElement.focus();
                        }
                    }
                }
            };
            
            this.modal.addEventListener('keydown', handleTabKey);
        }
        
        enhanceModalFunctionality() {
            // Enhance image selection
            this.enhanceImageSelection();
            
            // Add loading states
            this.addLoadingStates();
            
            // Improve accessibility
            this.improveAccessibility();
        }
        
        enhanceImageSelection() {
            document.addEventListener('change', (e) => {
                if (e.target.matches(config.radioInputSelector)) {
                    // Add visual feedback for selection
                    const wrapper = e.target.nextElementSibling;
                    if (wrapper) {
                        // Remove selection from other images
                        const allWrappers = document.querySelectorAll(config.imageWrapperSelector);
                        allWrappers.forEach(w => w.classList.remove('selected'));
                        
                        // Add selection to current image
                        wrapper.classList.add('selected');
                        
                        // Trigger selection animation
                        wrapper.style.transform = 'scale(1.05)';
                        setTimeout(() => {
                            wrapper.style.transform = '';
                        }, 200);
                    }
                }
            });
        }
        
        addLoadingStates() {
            // Add loading state for images
            const imageWrappers = document.querySelectorAll(config.imageWrapperSelector);
            imageWrappers.forEach(wrapper => {
                const img = wrapper.querySelector('img');
                if (img) {
                    wrapper.classList.add('loading');
                    
                    img.addEventListener('load', () => {
                        wrapper.classList.remove('loading');
                        wrapper.classList.add('loaded');
                    });
                    
                    img.addEventListener('error', () => {
                        wrapper.classList.remove('loading');
                        wrapper.classList.add('error');
                    });
                }
            });
        }
        
        improveAccessibility() {
            // Add ARIA labels and roles
            const closeButton = document.querySelector(config.closeButtonSelector);
            if (closeButton) {
                closeButton.setAttribute('aria-label', 'Close photo selection modal');
                closeButton.setAttribute('role', 'button');
            }
            
            // Add keyboard navigation for images
            const imageWrappers = document.querySelectorAll(config.imageWrapperSelector);
            imageWrappers.forEach(wrapper => {
                wrapper.setAttribute('tabindex', '0');
                wrapper.setAttribute('role', 'button');
                
                wrapper.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        const radio = wrapper.previousElementSibling;
                        if (radio && radio.matches(config.radioInputSelector)) {
                            radio.checked = true;
                            radio.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }
                });
            });
        }
        
        updateImageUrls() {
            if (!this.modal) return;
            
            // Find all images in the modal
            const images = this.modal.querySelectorAll('img.tcustomizer__image-content');
            
            images.forEach(img => {
                const currentSrc = img.getAttribute('src');
                if (currentSrc && currentSrc.includes('?w=100')) {
                    // Replace w=100 with w=600 for higher quality
                    const newSrc = currentSrc.replace('?w=100', '?w=600');
                    img.setAttribute('src', newSrc);
                    
                    // Log for debugging
                    console.log('Updated image URL:', currentSrc, '→', newSrc);
                }
            });
        }
        
        setupPhotoSelectionTracking() {
            if (!this.modal) return;
            
            console.log('TEPO Fullscreen Modal: Setting up photo selection tracking...');
            
            // Find all image wrappers
            const imageWrappers = this.modal.querySelectorAll(config.imageWrapperSelector);
            console.log('Found image wrappers:', imageWrappers.length);
            
            imageWrappers.forEach((wrapper, index) => {
                wrapper.addEventListener('click', () => {
                    console.log(`TEPO Fullscreen Modal: Image ${index} clicked`);
                    // Wait for TEPO to process the selection
                    setTimeout(() => {
                        this.updateActivatorText();
                    }, 200);
                });
            });
        }
        
        updateActivatorText() {
            // console.log('TEPO Fullscreen Modal: Updating activator text...');
            
            // Find the activator element - try multiple selectors
            const activator = document.querySelector('.tcustomizer-group-popup__activator span') || 
                            document.querySelector('.tcustomizer-group-popup__activator') ||
                            document.querySelector('[class*="activator"] span');
            
            // Find the photo selector container
            const photoSelector = document.querySelector('.swau-custom-photo-select');
            
            // console.log('Activator element found:', activator);
            if (!activator || !photoSelector) {
                // console.log('TEPO Fullscreen Modal: No activator element found');
                return;
            }
            
            // Find the selected image - try multiple selectors
            let selectedImage = this.modal.querySelector('.tcustomizer__btn-check:checked + .tcustomizer__image-wrapper img') ||
                                this.modal.querySelector('input[type="radio"]:checked + .tcustomizer__image-wrapper img') ||
                                this.modal.querySelector('.tcustomizer__image-wrapper.selected img') ||
                                this.modal.querySelector('.tcustomizer__image-wrapper[data-selected="true"] img') ||
                                this.modal.querySelector('.tcustomizer__image-wrapper.tcustomizer__image-wrapper--selected img') ||
                                this.modal.querySelector('.tcustomizer__image-wrapper[aria-checked="true"] img');
            
            console.log('Selected image found:', selectedImage);
            
            // If no image found with selectors, try to find by checking all image wrappers
            if (!selectedImage) {
                console.log('TEPO Fullscreen Modal: Trying alternative method to find selected image...');
                const allImageWrappers = this.modal.querySelectorAll('.tcustomizer__image-wrapper');
                console.log('All image wrappers:', allImageWrappers.length);
                
                for (let i = 0; i < allImageWrappers.length; i++) {
                    const wrapper = allImageWrappers[i];
                    
                    // Check if this is a label with a 'for' attribute
                    if (wrapper.tagName === 'LABEL' && wrapper.hasAttribute('for')) {
                        const forId = wrapper.getAttribute('for');
                        const radio = document.getElementById(forId);
                        
                        console.log(`Wrapper ${i}:`, {
                            wrapper: wrapper,
                            forId: forId,
                            radio: radio,
                            radioChecked: radio ? radio.checked : 'N/A',
                            classes: wrapper.className,
                            attributes: wrapper.getAttributeNames()
                        });
                        
                        if (radio && radio.checked) {
                            const img = wrapper.querySelector('img');
                            if (img) {
                                console.log(`TEPO Fullscreen Modal: Found selected image in wrapper ${i}`);
                                selectedImage = img;
                                break;
                            }
                        }
                    } else {
                        // Fallback for direct input checking
                        const radio = wrapper.querySelector('input[type="radio"]');
                        const checkbox = wrapper.querySelector('input[type="checkbox"]');
                        
                        console.log(`Wrapper ${i}:`, {
                            wrapper: wrapper,
                            radio: radio,
                            radioChecked: radio ? radio.checked : 'N/A',
                            checkbox: checkbox,
                            checkboxChecked: checkbox ? checkbox.checked : 'N/A',
                            classes: wrapper.className,
                            attributes: wrapper.getAttributeNames()
                        });
                        
                        if ((radio && radio.checked) || (checkbox && checkbox.checked)) {
                            const img = wrapper.querySelector('img');
                            if (img) {
                                console.log(`TEPO Fullscreen Modal: Found selected image in wrapper ${i}`);
                                selectedImage = img;
                                break;
                            }
                        }
                    }
                }
            }
            
            // If still no image found, try looking for TEPO's visual indicators
            if (!selectedImage) {
                console.log('TEPO Fullscreen Modal: Trying visual indicator method...');
                
                // Look for images with active/selected visual classes
                const activeImages = this.modal.querySelectorAll('.tcustomizer__image--active img, .tcustomizer__image--selected img');
                console.log('Active images found:', activeImages.length);
                
                if (activeImages.length > 0) {
                    selectedImage = activeImages[0];
                    console.log('TEPO Fullscreen Modal: Found selected image via visual indicator');
                }
            }
            
            if (selectedImage) {
                // Extract photo name from the image alt text or src
                let photoName = selectedImage.alt || 'Photo';
                
                // If no alt text, try to extract from filename
                if (photoName === 'Photo' && selectedImage.src) {
                    const filename = selectedImage.src.split('/').pop().split('?')[0];
                    photoName = filename.replace(/\.(jpg|jpeg|png|webp)$/i, '');
                }
                
                // console.log('Photo name extracted:', photoName);
                
                // Update the activator text and add selected class
                activator.textContent = `Photo ${photoName} Selected`;
                photoSelector.classList.add('swau-photo-selected');
                // console.log('TEPO Fullscreen Modal: Updated activator text to:', activator.textContent);
            } else {
                // No photo selected, revert to default
                activator.textContent = 'Select SWAU Photo';
                photoSelector.classList.remove('swau-photo-selected');
                // console.log('TEPO Fullscreen Modal: No photo selected, reverted to default text');
            }
        }
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            new TEPOFullscreenModal();
        });
    } else {
        new TEPOFullscreenModal();
    }
    
    // Export for global access if needed
    window.TEPOFullscreenModal = TEPOFullscreenModal;
    
})();
